/* eslint-disable no-console */
type LogLevel = 'fatal' | 'error' | 'warn' | 'info' | 'debug' | 'trace';

type LogData = Record<string, unknown> & { error?: unknown };

type LogMethod = (data?: LogData, message?: string) => void;

const levelMap: Record<LogLevel, number> = {
  fatal: 60,
  error: 50,
  warn: 40,
  info: 30,
  debug: 20,
  trace: 10,
};

const formatError = (error: unknown) => {
  if (error === undefined) {
    return {};
  }

  if (error instanceof Error) {
    return {
      error: error.message,
      errorName: error.name,
      stack: error.stack,
    };
  }

  return { error };
};

const formatLogData = (level: number, data: LogData = {}, message?: string) => {
  const { error, ...rest } = data ?? {};

  return {
    ...rest,
    ...formatError(error),
    ...(message ? { message } : {}),
    level,
    timestamp: new Date().toISOString(),
    name: 'oat-frontend',
  };
};

const createLogger = (): Record<LogLevel, LogMethod> => {
  const createMethod =
    (level: number): LogMethod =>
    (data = {}, message?) => {
      console.log(formatLogData(level, data, message));
    };

  return (Object.keys(levelMap) as LogLevel[]).reduce(
    (accumulator, name) => ({
      ...accumulator,
      [name]: createMethod(levelMap[name]),
    }),
    {} as Record<LogLevel, LogMethod>
  );
};

export default createLogger();
